export default "__VITE_ASSET__dti7RM0l__"